import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=72992cdd&scoped=true&"
import script from "./Speaker.vue?vue&type=script&lang=js&"
export * from "./Speaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72992cdd",
  null
  
)

export default component.exports